/**
 * Curious Shipping Protection (ASP) — Curious Campervans
 * Optimised: single cart fetch, instant render, sync cooldown
 */
(function () {
  'use strict';
  if (window.__asp_loaded) return;
  window.__asp_loaded = true;

  var OPT_OUT_KEY  = 'asp_declined';
  var PROTECT_SKU  = 'CURIOUS-PROTECT';

  var TIERS = [
    { min: 1,       max: 9999,    id: 47835709341954, cents: 395   },
    { min: 10000,   max: 24999,   id: 47835709571330, cents: 795   },
    { min: 25000,   max: 49999,   id: 47835709604098, cents: 1495  },
    { min: 50000,   max: 99999,   id: 47835709636866, cents: 2495  },
    { min: 100000,  max: 149999,  id: 47835709669634, cents: 4495  },
    { min: 150000,  max: 199999,  id: 47835709899010, cents: 7495  },
    { min: 200000,  max: 249999,  id: 47835709931778, cents: 9495  },
    { min: 250000,  max: 349999,  id: 47835709964546, cents: 12495 },
    { min: 350000,  max: 499999,  id: 47835709997314, cents: 17495 },
    { min: 500000,  max: 749999,  id: 47835710062850, cents: 22495 },
    { min: 750000,  max: 999999,  id: 47835710095618, cents: 32495 },
    { min: 1000000, max: Infinity, id: 47835710128386, cents: 42495 }
  ];

  var _syncing      = false;
  var _lastHash     = null;
  var _running      = false;
  var _cartWasEmpty = true;
  var _cachedCart   = null;
  var _cacheTime    = 0;
  var _lastSyncAt   = 0;
  var CACHE_TTL     = 4000;
  var SYNC_COOLDOWN = 2500;

  function isDeclined() { try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch(e) { return false; } }
  function setDeclined(v) { try { v ? sessionStorage.setItem(OPT_OUT_KEY,'1') : sessionStorage.removeItem(OPT_OUT_KEY); } catch(e) {} }
  function fmt(cents) {
    return new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD',minimumFractionDigits:2}).format(cents/100);
  }
  function cartHash(cart) {
    return cart.items.map(function(i){return i.key+':'+i.quantity+':'+i.variant_id;}).sort().join('|');
  }
  function syncedRecently() { return (Date.now() - _lastSyncAt) < SYNC_COOLDOWN; }

  function fetchCart(force) {
    var now = Date.now();
    if (!force && _cachedCart && (now - _cacheTime) < CACHE_TTL) return Promise.resolve(_cachedCart);
    return fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ _cachedCart=cart; _cacheTime=Date.now(); return cart; });
  }
  function bustCache() { _cachedCart=null; _cacheTime=0; }

  function isProtect(item) {
    return String(item.sku||'').indexOf(PROTECT_SKU)===0
        || String(item.product_title||'').toLowerCase().indexOf('shipping protection')!==-1;
  }
  function protectItems(cart)  { return cart.items.filter(isProtect); }
  function realSubtotal(cart)  { return cart.items.reduce(function(s,i){return isProtect(i)?s:s+(i.final_line_price||0);},0); }
  function realCount(cart)     { return cart.items.reduce(function(n,i){return isProtect(i)?n:n+(i.quantity||0);},0); }
  function tierFor(sub) {
    for(var i=0;i<TIERS.length;i++) if(sub>=TIERS[i].min&&sub<=TIERS[i].max) return TIERS[i];
    return null;
  }
  function addProtect(id) {
    return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:Number(id),quantity:1,properties:{_shipping_protection:'true',_coverage_program:'Curious Shipping Protection'}})
    });
  }
  function removeItems(items) {
    return items.reduce(function(p,item){
      return p.then(function(){
        return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:item.key,quantity:0})
        });
      });
    },Promise.resolve());
  }
  function removeAllProtect() {
    bustCache();
    return fetchCart(true).then(function(c){return removeItems(protectItems(c));});
  }
  function syncProtectWithCart(id, cart) {
    var prot=protectItems(cart);
    var ok=prot.filter(function(i){return Number(i.variant_id)===Number(id)&&i.quantity===1;});
    if(prot.length===1&&ok.length===1) return Promise.resolve(false);
    bustCache();
    return removeItems(prot).then(function(){
      return addProtect(id).then(function(r){if(!r.ok) throw new Error('add failed'); return true;});
    });
  }

  function updateSubtotalDisplay(sub) {
    document.querySelectorAll('[data-subtotal]').forEach(function(el){
      var orig=el.querySelector('.wcp-original-cart-total');
      if(orig) orig.textContent=fmt(sub); else el.textContent=fmt(sub);
    });
  }

  var cssOk=false;
  function ensureCSS() {
    if(cssOk) return; cssOk=true;
    var s=document.createElement('style');
    s.textContent=[
      '.asp-widget{margin:12px 0;padding:12px 14px;border:1.5px solid #c8a84b;border-radius:8px;background:linear-gradient(135deg,#fffdf4 0%,#fffef9 100%);box-shadow:0 1px 4px rgba(180,150,60,.10);transition:box-shadow .2s;}',
      '.asp-widget:has(.asp-widget__check:checked){background:linear-gradient(135deg,#fffbea 0%,#fffef5 100%);box-shadow:0 2px 8px rgba(180,150,60,.18);}',
      '.asp-widget__row{display:grid;grid-template-columns:20px 32px 1fr auto;gap:10px;align-items:center;cursor:pointer;margin:0;}',
      '.asp-widget__row input[type=checkbox]{width:17px;height:17px;margin:0;cursor:pointer;accent-color:#c8a84b;flex-shrink:0;}',
      '.asp-widget__icon{width:32px;height:32px;border-radius:50%;background:#c8a84b;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '.asp-widget__icon svg{display:block;}',
      '.asp-widget__text{min-width:0;}',
      '.asp-widget__title{font-size:13px;font-weight:700;color:#1a1a1a;line-height:1.3;margin:0 0 2px;}',
      '.asp-widget__copy{font-size:11px;color:#666;line-height:1.4;margin:0;}',
      '.asp-widget__price{font-size:13px;font-weight:700;color:#1a1a1a;white-space:nowrap;text-align:right;}',
      '.asp-widget__msg{margin:6px 0 0 62px;font-size:11px;color:#999;min-height:0;}',
      '.asp-hidden{display:none!important;}'
    ].join('');
    document.head.appendChild(s);
  }

  var SHIELD='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L4 5.5V11c0 4.418 3.356 8.167 8 9 4.644-.833 8-4.582 8-9V5.5L12 2z" fill="white" opacity="0.95"/><path d="M9 12l2 2 4-4" stroke="#c8a84b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderWidget(mount, tier, declined) {
    ensureCSS();
    if (!mount.querySelector('.asp-widget')) {
      mount.innerHTML=[
        '<div class="asp-widget">',
          '<label class="asp-widget__row">',
            '<input type="checkbox" class="asp-widget__check">',
            '<span class="asp-widget__icon">'+SHIELD+'</span>',
            '<span class="asp-widget__text">',
              '<p class="asp-widget__title">Curious Shipping Protection</p>',
              '<p class="asp-widget__copy">Covers loss, theft &amp; damage during shipping</p>',
            '</span>',
            '<span class="asp-widget__price"></span>',
          '</label>',
          '<div class="asp-widget__msg"></div>',
        '</div>'
      ].join('');
    }
    mount.querySelector('.asp-widget__price').textContent=fmt(tier.cents);
    var chk=mount.querySelector('.asp-widget__check');
    chk.checked=!declined; chk.disabled=false;
  }
  function setMsg(mount,txt){var el=mount&&mount.querySelector('.asp-widget__msg');if(el) el.textContent=txt||'';}

  function hideProtectLines(cart) {
    var keys=protectItems(cart).map(function(i){return String(i.key);});
    keys.forEach(function(key){
      document.querySelectorAll('[data-key="'+key+'"]').forEach(function(el){el.classList.add('asp-hidden');});
    });
    document.querySelectorAll('.cart__item,[class*="qsc2-product"],[class*="qsc2-item"],[class*="qsc2-cart-item"]').forEach(function(el){
      var txt=(el.textContent||'').toLowerCase();
      if(txt.indexOf('shipping protection')!==-1||txt.indexOf('curious-protect')!==-1) el.classList.add('asp-hidden');
    });
  }

  function findVisibleCheckoutWrapper() {
    var qsc=document.querySelector('.qsc2-drawer-footer__checkout');
    if(qsc){var r=qsc.getBoundingClientRect();if(r.width>0||r.height>0) return qsc;}
    var btns=document.querySelectorAll('button[name="checkout"],input[name="checkout"],.qsc2-checkout-button');
    for(var i=0;i<btns.length;i++){
      if(btns[i].closest('#CartPageForm')) continue;
      var br=btns[i].getBoundingClientRect();
      if(br.width>0||br.height>0) return btns[i].closest('.cart__checkout-wrapper,.payment-buttons,.qsc2-drawer-footer__checkout')||btns[i].parentElement;
    }
    return null;
  }
  function injectDrawerMount() {
    var ex=document.querySelector('[data-asp-mount="drawer-live"]');
    if(ex){var er=ex.getBoundingClientRect();if(er.width>0||er.height>0) return ex; ex.remove();}
    var wrapper=findVisibleCheckoutWrapper();
    if(!wrapper||!wrapper.parentElement) return null;
    var mount=document.createElement('div');
    mount.setAttribute('data-asp-mount','drawer-live');
    wrapper.parentElement.insertBefore(mount,wrapper);
    return mount;
  }

  function initMount(mount, cart, force) {
    if(_syncing) return;
    hideProtectLines(cart);
    var rc=realCount(cart);
    if(rc===0&&protectItems(cart).length>0){bustCache();removeAllProtect().catch(function(){});mount.hidden=true;return;}
    if(rc===0){mount.hidden=true;return;}
    var tier=tierFor(realSubtotal(cart));
    if(!tier){mount.hidden=true;return;}

    mount.hidden=false;
    renderWidget(mount,tier,isDeclined());

    var hash=cartHash(cart);
    if(!force&&mount.getAttribute('data-asp-cart-hash')===hash) return;

    if(isDeclined()){
      var prot=protectItems(cart);
      if(prot.length>0){
        _syncing=true;bustCache();
        removeItems(prot).then(function(){
          _syncing=false;_lastSyncAt=Date.now();
          mount.setAttribute('data-asp-cart-hash','');
          updateSubtotalDisplay(realSubtotal(cart)-prot.reduce(function(s,i){return s+(i.final_line_price||0);},0));
          hideProtectLines({items:[]});
        }).catch(function(){_syncing=false;});
      }
      mount.setAttribute('data-asp-cart-hash',hash);
      return;
    }

    _syncing=true;
    syncProtectWithCart(tier.id,cart).then(function(changed){
      _syncing=false;
      _lastSyncAt=Date.now();
      if(changed){
        bustCache();
        fetchCart(true).then(function(updated){
          hideProtectLines(updated);
          updateSubtotalDisplay(realSubtotal(updated)+tier.cents);
          mount.setAttribute('data-asp-cart-hash',cartHash(updated));
          _lastHash=cartHash(updated);
        });
      } else {
        mount.setAttribute('data-asp-cart-hash',hash);
      }
    }).catch(function(){_syncing=false;setMsg(mount,'Could not update protection — please refresh.');});
  }

  function runAll(force) {
    if(_running) return;
    _running=true;
    fetchCart(force).then(function(cart){
      var hash=cartHash(cart);
      var changed=(hash!==_lastHash);
      _lastHash=hash;
      _running=false;
      var rc=realCount(cart);
      if(_cartWasEmpty&&rc>0) setDeclined(false);
      _cartWasEmpty=(rc===0);
      hideProtectLines(cart);
      document.querySelectorAll('[data-asp-mount]').forEach(function(mount){
        if(mount.getAttribute('data-asp-mount')==='drawer-live') return;
        var r=mount.getBoundingClientRect();
        if(r.width===0&&r.height===0) return;
        initMount(mount,cart,changed||force);
      });
      var dm=injectDrawerMount();
      if(dm) initMount(dm,cart,changed||force||!dm.getAttribute('data-asp-cart-hash'));
    }).catch(function(){_running=false;});
  }

  document.addEventListener('change',function(e){
    var chk=e.target;
    if(!chk||!chk.classList.contains('asp-widget__check')) return;
    if(_syncing){e.preventDefault();return;}
    var mount=chk.closest('[data-asp-mount]');
    if(!mount) return;
    var checked=chk.checked;
    setDeclined(!checked);
    chk.disabled=true;
    mount.setAttribute('data-asp-cart-hash','');
    _syncing=true;bustCache();
    if(checked){
      fetchCart(true).then(function(cart){
        var tier=tierFor(realSubtotal(cart));
        if(!tier){setDeclined(false);_syncing=false;chk.disabled=false;return;}
        return syncProtectWithCart(tier.id,cart).then(function(){
          bustCache();_syncing=false;_lastSyncAt=Date.now();_lastHash=null;
          fetchCart(true).then(function(updated){
            hideProtectLines(updated);
            updateSubtotalDisplay(realSubtotal(updated)+tier.cents);
            renderWidget(mount,tier,false);
            mount.setAttribute('data-asp-cart-hash',cartHash(updated));
            chk.disabled=false;
          });
        });
      }).catch(function(){
        setDeclined(false);chk.checked=false;_syncing=false;chk.disabled=false;
        setMsg(mount,'Could not add protection — please refresh.');
      });
    } else {
      removeAllProtect().then(function(){
        bustCache();_syncing=false;_lastSyncAt=Date.now();_lastHash=null;
        fetchCart(true).then(function(updated){
          hideProtectLines(updated);
          updateSubtotalDisplay(realSubtotal(updated));
          var tier=tierFor(realSubtotal(updated));
          if(tier) renderWidget(mount,tier,true);
          mount.setAttribute('data-asp-cart-hash',cartHash(updated));
          chk.disabled=false;
        });
      }).catch(function(){
        setDeclined(false);chk.checked=true;_syncing=false;chk.disabled=false;
        setMsg(mount,'Could not remove protection — please refresh.');
      });
    }
  });

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){runAll(true);});
  else runAll(true);

  ['page:loaded','CartDrawer:open','drawerOpen','drawer:open','cart:open',
   'cart:updated','cart:refresh','ajaxProduct:added','ajaxCart:updated'].forEach(function(ev){
    document.addEventListener(ev,function(){
      var old=document.querySelector('[data-asp-mount="drawer-live"]');
      if(old) old.remove();
      if(!syncedRecently()){bustCache();_lastHash=null;}
      setTimeout(function(){runAll(!syncedRecently());},150);
    });
  });

  try {
    var _moTimer=null;
    new MutationObserver(function(muts){
      var relevant=muts.some(function(m){
        if(m.target.closest&&m.target.closest('[data-asp-mount]')) return false;
        if(m.target.nodeType===1){var cls=String(m.target.className||'');if(cls.indexOf('asp-')!==-1) return false;}
        for(var i=0;i<m.addedNodes.length;i++){
          var n=m.addedNodes[i];if(n.nodeType!==1) continue;
          var nc=String(n.className||'');
          if(nc.indexOf('qsc2')!==-1) return true;
          if(n.querySelector&&n.querySelector('[class*="qsc2-drawer"]')) return true;
        }
        if(m.type==='attributes'&&m.attributeName==='aria-hidden'&&String(m.target.className||'').indexOf('qsc2')!==-1) return true;
        return false;
      });
      if(!relevant) return;
      clearTimeout(_moTimer);
      _moTimer=setTimeout(function(){
        var old=document.querySelector('[data-asp-mount="drawer-live"]');
        if(old) old.remove();
        // Cooldown: if we just synced, Qikify is re-rendering from our own cart change.
        // Re-inject mount and render from cache only — no new API sync.
        if(syncedRecently()){
          runAll(false);
        } else {
          bustCache();_lastHash=null;
          runAll(true);
        }
      },250);
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-hidden','class']});
  } catch(e){}

})();
